"use strict";

import Page from "./BundlePurchase.jsx";

export const auth = true;
export const title = "i18n:bundlePurchase.pageTitle";
export const Component = Page;
